import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../config/supabase';
import { toast } from 'sonner';

/**
 * Hook para sincronizar sessão Supabase via URL query params.
 * Útil para SSO via iframe ou links externos autenticados.
 * Busca por 'access_token' e 'refresh_token' na URL.
 */
export const useTokenSync = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');
    const type = params.get('type'); // 'recovery', 'invite', etc. (opcional)

    if (accessToken && refreshToken) {
      const setSession = async () => {
        try {
          console.log('🔄 Sincronizando sessão via URL tokens...');
          
          const { error } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken,
          });

          if (error) throw error;

          toast.success('Login sincronizado com sucesso!');
          
          // Limpar tokens da URL para segurança e estética
          const newParams = new URLSearchParams(location.search);
          newParams.delete('access_token');
          newParams.delete('refresh_token');
          newParams.delete('type'); // Se houver
          
          navigate({
            pathname: location.pathname,
            search: newParams.toString()
          }, { replace: true });
          
        } catch (error) {
          console.error('❌ Erro ao sincronizar sessão:', error);
          toast.error('Falha na autenticação automática');
        }
      };

      setSession();
    }
  }, [location.search, navigate]);
};
